const pmtilesUrl = 'https://gis.weathernews.jp/json/global/overture/latest.json'

export const mapStyle = {
  version: 8,
  sources: {
    worldSource: {
      type: 'vector',
      tiles: [
        'https://tpf.weathernews.jp/map/ne_10m_admin_0_countries/{z}/{x}/{y}.pbf'
      ],
      tileSize: 512,
      maxzoom: 8
    },
    // worldElevation: {
    //  type: 'raster',
    //  tiles: [
    //    'https://tpf.weathernews.jp/map/SR_50M/{z}/{x}/{y}.png'
    //  ],
    //  tileSize: 256,
    //  maxzoom: 5
    // },
    overture: {
      type: 'vector',
      url: pmtilesUrl
    }
  },
  glyphs: 'https://gsi-cyberjapan.github.io/optimal_bvmap/glyphs/{fontstack}/{range}.pbf',
  layers: [
    {
      id: 'background',
      type: 'background',
      paint: {
        'background-color': '#738CC2'
      }
    },
    {
      'id': 'fillLand',
      'type': 'fill',
      'source': 'overture',
      'source-layer': 'base/land/land/mask',
      'paint': {
        'fill-color': '#A1C1A4'
      }
    },
    {
      'id': 'lineRegion',
      'type': 'line',
      'source': 'overture',
      'source-layer': 'divisions/division_area/region',
      'minzoom': 3,
      'paint': {
        'line-color': '#7ba184',
        'line-width': ['interpolate', ['linear'], ['zoom'], 4, 0.6, 8, 1.5]
      }
    },
    {
      'id': 'lineCountry',
      'type': 'line',
      'source': 'overture',
      'source-layer': 'divisions/division_area/country',
      'paint': {
        'line-color': '#6e9175',
        'line-width': ['interpolate', ['linear'], ['zoom'], 2, 0.6, 4, 1.2, 8, 2]
      }
    },
    // {
    //  id: 'elevation',
    //  type: 'raster',
    //  source: 'worldElevation',
    //  paint: {
    //    'raster-opacity': 0.8,
    //    'raster-contrast': 0.4
    //  }
    // },
    {
      'id': 'symbolRegion',
      'type': 'symbol',
      'source': 'overture',
      'source-layer': 'divisions/division/region/symbol',
      'minzoom': 3,
      'layout': {
        'text-font': ['NotoSansJP-Regular'],
        'text-field': [
          'coalesce',
          ['get', 'names.ja']
        ],
        'text-size': ['interpolate', ['linear'], ['zoom'], 3, 10, 8, 15],
        'text-padding': 7
      },
      'paint': {
        'text-color': '#ffffff',
        'text-halo-color': '#628269',
        'text-halo-width': 1
      }
    },
    {
      'id': 'symbolCountry',
      'type': 'symbol',
      'source': 'overture',
      'source-layer': 'divisions/division/country/symbol',
      // minzoom: 1.5,
      'maxzoom': 3.5,
      'layout': {
        'text-font': ['NotoSansJP-Regular'],
        'text-field': [
          'coalesce',
          ['get', 'names.ja']
        ],
        'text-size': ['interpolate', ['linear'], ['zoom'], 1.5, 10, 3.5, 12],
        'text-padding': 7
      },
      'paint': {
        'text-color': '#3d5743',
        'text-halo-color': '#ebebeb',
        'text-halo-width': ['interpolate', ['linear'], ['zoom'], 1.5, 0.9, 4, 1.2]
      }
    },
    {
      'id': 'symbolOcean',
      'type': 'symbol',
      'source': 'overture',
      'source-layer': 'base/water/ocean/symbol',
      'maxzoom': 10,
      'layout': {
        'text-font': ['NotoSerifJP-SemiBold'],
        'text-field': [
          'coalesce',
          ['get', 'names.ja']
        ],
        'text-size': 10
      },
      'paint': {
        'text-color': '#0c419a'
        // 'text-halo-color': '#ffffff',
        // 'text-halo-width': 1.5
      }
    }
  ]
}
